export const DatadogCustomMetrics = {
  BASE_NAME: 'vaccardsweb_',
  PERFORMANCE: 'performance',
  WEBVITALS: 'webvitals',
};

export const LOG_TYPES_FOR_DATADOG_CUSTOM_METRICS = [
  DatadogCustomMetrics.PERFORMANCE,
];

export const DD_METRIC_TAG_KEYS_FOR_LOG_TYPE_PERFORMANCE = [
  'app',
  'env',
  'event',
  'channelOriginId',
  'logType',
  'method',
  'requestRoute',
];
